import { isTruthy } from './array';

/**
 * Really really simple pluralizer. This literally just appends an 's' to the string and doesn't do anything special for other words (person/people, sheep/sheep etc.)
 */
export const pluralize = (str: string, count: number) =>
  `${str}${count === 1 ? '' : 's'}`;

export const removeFirstCharacter = (str: string) => str.slice(1, str.length);

/**
 * Accepts an array of items, filters out the falsy entries and joins with the supplied delimiter.
 */
export const joinPresent = (
  items: (string | undefined | null | false)[],
  delimiter?: string
) => items.filter(isTruthy).join(delimiter);
